// extracted by mini-css-extract-plugin
export var dropdown = "_qx-0";
export var imageWrapper = "_qx-3";
export var itemNameContainer = "_qx-1";
export var productImage = "_qx-2";
export var spinnerWrapper = "_qx-4";